import { render, staticRenderFns } from "./EditPromocode.vue?vue&type=template&id=490be867&scoped=true&"
import script from "./EditPromocode.vue?vue&type=script&lang=js&"
export * from "./EditPromocode.vue?vue&type=script&lang=js&"
import style0 from "./EditPromocode.vue?vue&type=style&index=0&id=490be867&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490be867",
  null
  
)

export default component.exports